export const Darkmode = ".Darkmode &"; //"@media (prefers-color-scheme: dark)";
